import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { QuestionarioUGService } from 'src/app/services/questionarioug.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-modal-solicitar-preenchimento-shared',
  templateUrl: './modal-solicitar-preenchimento.component.html',
  styleUrls: ['./modal-solicitar-preenchimento.component.scss']
})
export class ModalSolicitarPreenchimentoSharedComponent implements OnInit {
  prazoDias: number;
  unidadeGestoraId: number;

  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private questionarioUGService: QuestionarioUGService,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<ModalSolicitarPreenchimentoSharedComponent>

  ) { }
  public mensagemAlerta: string;

  ngOnInit(): void {
    this.unidadeGestoraId = this.sharedService.getId();
  }

  public cancelar(){
    this.dialogRef.close();
  }

  public concluir(){
    if (!this.prazoDias || this.prazoDias < 1) {
      this.exibirMensagemAlerta("Preencha um prazo!");
      return;
    }

    this.questionarioUGService
    .solicitarPreenchimentoQuestionario(this.data.param1, this.prazoDias)
    .then((res) => {
      if (res.sucesso) {
        // aqui chamar o pagina principal
        this.dialogRef.close();
      } else {
        // this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    })
    .catch((err) => {
      // this.exibirMensagemErro(err.mensagem);
    })
    .finally(() => {
      //  this.buscar();
    });
  }

  public onChangePreencherPrazo(event){
    this.prazoDias = event.target.value;
  }

  public exibirMensagemAlerta(mensagem: string): void{
      this.mensagemAlerta = mensagem;
  }

}
